
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-right"
      richColors={false}
      closeButton={true}
      duration={5000}
      expand={false}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-white group-[.toaster]:text-expitrack-text group-[.toaster]:border-expitrack-primary/20 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
          title: "group-[.toast]:text-expitrack-text group-[.toast]:font-semibold",
          description: "group-[.toast]:text-expitrack-text/80",
          actionButton: "group-[.toast]:bg-expitrack-primary group-[.toast]:text-white group-[.toast]:rounded-md",
          cancelButton: "group-[.toast]:bg-gray-100 group-[.toast]:text-expitrack-text group-[.toast]:rounded-md",
          success: "group-[.toaster]:bg-white group-[.toaster]:border-green-500/50 group-[.toaster]:text-green-700 [&>svg]:text-green-500",
          error: "group-[.toaster]:bg-white group-[.toaster]:border-red-500/50 group-[.toaster]:text-red-700 [&>svg]:text-red-500",
          warning: "group-[.toaster]:bg-white group-[.toaster]:border-yellow-500/50 group-[.toaster]:text-yellow-700 [&>svg]:text-yellow-500",
          info: "group-[.toaster]:bg-white group-[.toaster]:border-blue-500/50 group-[.toaster]:text-blue-700 [&>svg]:text-blue-500",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
